import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cx } from '../../../utils/cx';
import styles from './IconButton.module.scss';
import React from 'react';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    label?: string;
    tone?: 'default' | 'danger';
    children: ReactNode;
}

export function IconButton({
    label,
    tone = 'default',
    children,
    className,
    type = 'button',
    ...rest
}: IconButtonProps) {
    return (
        <button
            type={type}
            className={cx(styles.iconBtn, tone === 'danger' && styles.danger, className)}
            title={label}
            aria-label={label}
            {...rest}
        >
            {children}
        </button>
    );
}
